import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function RevisitDetails({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (isError[name]) {
      setIsError((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!primaryDetails.revisit_detail) {
      errors.revisit_detail = true;
    }
    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    return !!primaryDetails.revisit_detail;
  };
  const handleNext = () => {
    if (validateForm()) {
      navigation.go("remarks");
    } else {
      toast.error("Please fill in all required fields.");
    }
  };

  const handleBack = () => {
    navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">REVISIT DETAILS</h4>
              <p className="form-desc">Please provide revisit details</p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  {/* Revisit Details */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Revisit Details
                      <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="revisit_detail"
                      value={primaryDetails.revisit_detail || ""}
                      onChange={handleInputChange}
                      placeholder="Short answer text"
                      className={`form-input ${
                        isError.revisit_detail ? "form-input-error" : ""
                      }`}
                    />
                    {isError.revisit_detail && (
                      <div className="form-error">
                        Revisit details are required.
                      </div>
                    )}
                    <div>
                      <p className="form-note-text">
                        <em>"Note: For negative/failed visit - TAS failed to engage the merchant."</em>
                      </p>
                    </div>
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back 
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default RevisitDetails;
